// 툴팁 이미지 import
import tooltipCompanyName from '../../asset/img/tooltip/tooltip_company_name.jpg';
import tooltipBusinessNumber from '../../asset/img/tooltip/tooltip_business_number.jpg';
import tooltipWorkPeriod from '../../asset/img/tooltip/tooltip_work_period.jpg';
import tooltipSalary from '../../asset/img/tooltip/tooltip_salary.jpg';
import tooltipNationalPension from '../../asset/img/tooltip/tooltip_national_pension.jpg';
import tooltipHealthInsurance from '../../asset/img/tooltip/tooltip_health_insurance.jpg';
import tooltipEmploymentInsurance from '../../asset/img/tooltip/tooltip_employment_insurance.jpg';
import tooltipIncomeTax from '../../asset/img/tooltip/tooltip_income_tax.jpg';
import tooltipLocalIncomeTax from '../../asset/img/tooltip/tooltip_local_income_tax.jpg';
import tooltipReductionPeriod from '../../asset/img/tooltip/tooltip_reduction_period.jpg';
import tooltipBonus from '../../asset/img/tooltip/tooltip_bonus.jpg';
import tooltipDeemedBonus from '../../asset/img/tooltip/tooltip_deemed_bonus.jpg';
import tooltipStockOption from '../../asset/img/tooltip/tooltip_stock_option.jpg';
import tooltipEmployeeStock from '../../asset/img/tooltip/tooltip_employee_stock.jpg';
import tooltipExecutiveRetirement from '../../asset/img/tooltip/tooltip_executive_retirement.jpg';
import tooltipInventionReward from '../../asset/img/tooltip/tooltip_invention_reward.jpg';
import tooltipSpecialIncomeTax from '../../asset/img/tooltip/tooltip_special_income_tax.jpg';
import tooltipSpecialLocalTax from '../../asset/img/tooltip/tooltip_special_local_tax.jpg';
import tooltipPublicPension from '../../asset/img/tooltip/tooltip_public_pension.jpg';
import tooltipMilitaryPension from '../../asset/img/tooltip/tooltip_military_pension.jpg';
import tooltipPrivateSchoolPension from '../../asset/img/tooltip/tooltip_private_school_pension.jpg';
import tooltipPostalPension from '../../asset/img/tooltip/tooltip_postal_pension.jpg';
import tooltipTaxReduction from '../../asset/img/tooltip/tooltip_tax_reduction.jpg';
import tooltipTaxExempt from '../../asset/img/tooltip/tooltip_tax_exempt.jpg';

export const headerList = (t, detailDataList) => {
  const htmJType = detailDataList?.htmJType || '1';

  return [
    // 기본 정보 섹션
    {
      //근무처명
      title: t('basicInfoSection.title'),
      label: t('basicInfoSection.item1'),
      key: 'htm002',
      required: true,
      jType2Required: true,
      isNumber: false,
      description: t('tooltipSection.htm002'),
      tooltipImg: tooltipCompanyName,
    },
    {
      //사업자등록번호
      title: t('basicInfoSection.title'),
      label: t('basicInfoSection.item2'),
      key: 'htm003',
      required: true,
      jType2Required: true,
      isNumber: false,
      description: t('tooltipSection.htm003'),
      tooltipImg: tooltipBusinessNumber,
    },
    {
      //근무기간 (시작일/종료일)
      title: t('basicInfoSection.title'),
      label: t('basicInfoSection.item3'),
      key: 'htm019',
      endKey: 'htm020',
      required: true,
      jType2Required: true,
      isDate: true,
      description: t('tooltipSection.htm019'),
      tooltipImg: tooltipWorkPeriod,
    },
    {
      //급여
      title: htmJType == '1' ? t('basicInfoSection.title') : t('salarySection.title'),
      label: t('basicInfoSection.item4'),
      key: 'htm005',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm005'),
      tooltipImg: tooltipSalary,
    },
    {
      //국민연금보험료
      title: htmJType == '1' ? t('basicInfoSection.title') : t('insuranceSection.title'),
      label: t('basicInfoSection.item5'),
      key: 'htm014',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm014'),
      tooltipImg: tooltipNationalPension,
    },
    {
      //건강보험료
      title: htmJType == '1' ? t('basicInfoSection.title') : t('insuranceSection.title'),
      label: t('basicInfoSection.item6'),
      key: 'htm012',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm012'),
      tooltipImg: tooltipHealthInsurance,
    },
    {
      //고용보험료
      title: htmJType == '1' ? t('basicInfoSection.title') : t('insuranceSection.title'),
      label: t('basicInfoSection.item7'),
      key: 'htm013',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm013'),
      tooltipImg: tooltipEmploymentInsurance,
    },
    {
      //결정세액 소득세
      title: htmJType == '1' ? t('basicInfoSection.title') : t('taxSection.title'),
      label: t('basicInfoSection.item8'),
      key: 'htm015',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm015'),
      tooltipImg: tooltipIncomeTax,
    },
    {
      //결정세액 지방소득세
      title: htmJType == '1' ? t('basicInfoSection.title') : t('taxSection.title'),
      label: t('basicInfoSection.item9'),
      key: 'htm016',
      required: true,
      isNumber: true,
      description: t('tooltipSection.htm016'),
      tooltipImg: tooltipLocalIncomeTax,
    },

    // 감면 기간 섹션
    {
      //감면기간 (시작일/종료일)
      title: t('reductionSection.title'),
      label: t('reductionSection.period'),
      key: 'htm079',
      endKey: 'htm080',
      isDate: true,
      description: t('tooltipSection.htm079'),
      tooltipImg: tooltipReductionPeriod,
    },
    {
      //감면율
      title: t('reductionSection.title'),
      label: t('reductionSection.rate'),
      key: 'htm085',
      isSelect: true,
      options: [
        { name: '선택하세요', value: '' },
        { name: '70%', value: '70' },
        { name: '90%', value: '90' },
      ],
      description: t('tooltipSection.htm085'),
      tooltipImg: tooltipReductionPeriod,
    },

    {
      //상여
      title: t('salarySection.title'),
      label: t('salarySection.item2'),
      key: 'htm006',
      isNumber: true,
      description: t('tooltipSection.htm006'),
      tooltipImg: tooltipBonus,
    },
    {
      //인정상여
      title: t('salarySection.title'),
      label: t('salarySection.item3'),
      key: 'htm007',
      isNumber: true,
      description: t('tooltipSection.htm007'),
      tooltipImg: tooltipDeemedBonus,
    },
    {
      //주식매수선택권 행사이익
      title: t('salarySection.title'),
      label: t('salarySection.item4'),
      key: 'htm008',
      isNumber: true,
      description: t('tooltipSection.htm008'),
      tooltipImg: tooltipStockOption,
    },
    {
      //우리사주조합인출금
      title: t('salarySection.title'),
      label: t('salarySection.item5'),
      key: 'htm026',
      isNumber: true,
      description: t('tooltipSection.htm026'),
      tooltipImg: tooltipEmployeeStock,
    },
    {
      //임원 퇴직소득금액 한도초과액
      title: t('salarySection.title'),
      label: t('salarySection.item6'),
      key: 'htm081',
      isNumber: true,
      description: t('tooltipSection.htm081'),
      tooltipImg: tooltipExecutiveRetirement,
    },
    {
      //직무발명보상금
      title: t('salarySection.title'),
      label: t('salarySection.item7'),
      key: 'htm088',
      isNumber: true,
      description: t('tooltipSection.htm088'),
      tooltipImg: tooltipInventionReward,
    },

    // 납부특례세액 소득세
    {
      title: t('taxSection.title'),
      label: t('taxSection.item1'),
      key: 'htm083',
      isNumber: true,
      description: t('tooltipSection.htm083'),
      tooltipImg: tooltipSpecialIncomeTax,
    },
    {
      //납부특례세액 지방소득세
      title: t('taxSection.title'),
      label: t('taxSection.item2'),
      key: 'htm084',
      isNumber: true,
      description: t('tooltipSection.htm084'),
      tooltipImg: tooltipSpecialLocalTax,
    },

    // 연금보험 입력 섹션
    {
      //공무원연금
      title: t('pensionSection.title'),
      label: t('pensionSection.item1'),
      key: 'htm027',
      isNumber: true,
      description: t('tooltipSection.htm027'),
      tooltipImg: tooltipPublicPension,
    },
    {
      //군인연금
      title: t('pensionSection.title'),
      label: t('pensionSection.item2'),
      key: 'htm028',
      isNumber: true,
      description: t('tooltipSection.htm028'),
      tooltipImg: tooltipMilitaryPension,
    },
    {
      //사립학교교직원연금
      title: t('pensionSection.title'),
      label: t('pensionSection.item3'),
      key: 'htm029',
      isNumber: true,
      description: t('tooltipSection.htm029'),
      tooltipImg: tooltipPrivateSchoolPension,
    },
    {
      //우체국연금
      title: t('pensionSection.title'),
      label: t('pensionSection.item4'),
      key: 'htm030',
      isNumber: true,
      description: t('tooltipSection.htm030'),
      tooltipImg: tooltipPostalPension,
    },

    // 감면액 입력 섹션 (공통 이미지 사용)
    {
      //외국인기술자(50%)
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item1'),
      key: 'htm062',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //외국인기술자(70%)
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item2'),
      key: 'htm097',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //중소기업취업청년
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item3'),
      key: 'htm072',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //조세조약상교직자
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item4'),
      key: 'htm073',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //성과공유 중소기업의 경영성과급
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item5'),
      key: 'htm089',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //내국인 우수인력 국내 복귀 소득세감면
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item6'),
      key: 'htm090',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //중소기업 청년근로자 및 핵심인력 성과보상기금(50%) T40
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item7'),
      key: 'htm091',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //중견기업 청년근로자 및 핵심인력 성과보상기금(30%) T41
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item8'),
      key: 'htm094',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //중소기업 청년근로자 및 핵심인력 성과보상기금(90%) T42
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item9'),
      key: 'htm095',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },
    {
      //중견기업 청년근로자 및 핵심인력 성과보상기금(50%) T43
      title: t('taxReductionSection.title'),
      label: t('taxReductionSection.item10'),
      key: 'htm096',
      isNumber: true,
      description: t('tooltipSection.taxReduction'),
      tooltipImg: tooltipTaxReduction,
    },

    // 비과세 입력 섹션 (공통 이미지 사용)
    {
      //국외근로(100만원) M01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item1'),
      key: 'htm057',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //국외근로(500만원) M04
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item2'),
      key: 'htm058',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //국외근로 M03
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item3'),
      key: 'htm059',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //비과세식사대 P01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item4'),
      key: 'htm093',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //야간근로수당 O01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item5'),
      key: 'htm010',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //출산·보육수당 Q01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item6'),
      key: 'htm022',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //연구(유아,초등) H06
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item7'),
      key: 'htm045',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //연구(고등고육법) H07
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item8'),
      key: 'htm046',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //연구(특별법) H08
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item9'),
      key: 'htm047',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //연구(나-연구보조비특별법) H08
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item10'),
      key: 'htm048',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //연구(다-연구보조비) H10
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item11'),
      key: 'htm049',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //비과세장학금 G01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item12'),
      key: 'htm034',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //취재수당 H11
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item13'),
      key: 'htm075',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //벽지수당 H12
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item14'),
      key: 'htm076',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //천재지변재해수당 H13
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item15'),
      key: 'htm077',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //위원등이받는수당 H01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item16'),
      key: 'htm035',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //외국주둔군인급 K01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item17'),
      key: 'htm050',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //주식매수선택권 S01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item18'),
      key: 'htm061',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //우리사주인출금 50% Y02
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item19'),
      key: 'htm065',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //우리사주인출금 75% Y03
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item20'),
      key: 'htm066',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //우리사주인출금 100% Y04
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item21'),
      key: 'htm098',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //경호/승선수당 H05
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item22'),
      key: 'htm039',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //외국정부/국제기관 I01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item23'),
      key: 'htm078',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //이주수당 H16
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item24'),
      key: 'htm086',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //직무발명보상금 R11
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item25'),
      key: 'htm087',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //벤처기업 주식매수선택권 행사이익 U01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item26'),
      key: 'htm092',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //임원등 할인금액 W01
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item28'),
      key: 'htm102',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //수련보조수당 R12
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item27'),
      key: 'htm082',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //출산지원금(1회) Q03
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item29'),
      key: 'htm099',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
    {
      //출산지원금(2회) Q04
      title: t('taxExemptSection.title'),
      label: t('taxExemptSection.item30'),
      key: 'htm100',
      isNumber: true,
      description: t('tooltipSection.taxExempt'),
      tooltipImg: tooltipTaxExempt,
    },
  ];
};
